module.exports = __webpack_public_path__ + "media/images/self-service-bg-cdb7d94e4f04b42a900f3528dc59eb2c.png";